function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgWine = function SvgWine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297 297",
    style: {
      enableBackground: "new 0 0 297 297"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D95459"
    },
    cx: 148.5,
    cy: 148.5,
    r: 148.5
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B23F47"
    },
    d: "M212.757,65.72l-67.211,136.057c2.998,4.695,4.812,10.252,5.076,16.143 c0.09,2.004-0.063,3.97-0.428,5.878c0.444,1.931,0.719,3.922,0.81,5.954c0.724,16.175-14.284,29.951-29.951,29.951 c-1.36,0-2.688-0.099-3.987-0.273l-1.882,3.81l33.785,33.754c81.316-0.252,147.238-65.858,148.013-147.05L212.757,65.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M222,110.265c0-12.958-3.358-28.876-9.243-44.545H84.243C78.358,81.389,75,97.308,75,110.265 c0,38.202,29.147,69.587,66.414,73.153v67.691h-21.257c-3.913,0-7.086,3.172-7.086,7.086c0,3.913,3.172,7.086,7.086,7.086h21.257 h14.171h21.257c3.913,0,7.086-3.172,7.086-7.086c0-3.913-3.172-7.086-7.086-7.086h-21.257v-67.691 C192.853,179.852,222,148.467,222,110.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEE1E2"
    },
    d: "M222,110.265c0-12.958-3.358-28.876-9.243-44.545h-64.59v199.56h7.419h21.257 c3.913,0,7.085-3.172,7.085-7.086s-3.172-7.086-7.085-7.086h-21.257v-67.691C192.853,179.852,222,148.467,222,110.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#79302A"
    },
    d: "M87.162,112.661c0,33.876,27.462,61.338,61.338,61.338s61.338-27.462,61.338-61.338 C209.838,112.661,87.162,112.661,87.162,112.661z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#662522"
    },
    d: "M148.167,112.661v61.33c0.112,0.001,0.221,0.008,0.333,0.008c33.876,0,61.338-27.462,61.338-61.338 C209.838,112.661,148.167,112.661,148.167,112.661z"
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wine.545c93ca.svg";
export { ForwardRef as ReactComponent };